import { render } from "./EscalierMarron.vue?vue&type=template&id=7c902ca0"
import script from "./EscalierMarron.vue?vue&type=script&lang=js"
export * from "./EscalierMarron.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__